import { apiGet } from '@gat-ship/http-client'
import type { AgencyServedPortRef } from '@gat-ship/types'

/** Gets the active ports connected to a given agency. */
export async function getAgencyPortsRequest(agencyId: string) {
  return await apiGet<AgencyServedPortRef[]>(
    'ref-data/organization/agencies/ports',
    { params: { agency_id: agencyId } }
  )
}
